// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3uoz8","filesListContainer":"PosDisputesFiles_filesListContainer__aRaBb","filesButton":"PosDisputesFiles_filesButton__1v-PX"};